'use client';

import type { ExternalNetworkDto } from '@terra/shared-contracts-external-network';
import { ExternalNetworkGeneralSettings } from '@terra/ui-design-system';
import { usePersistExternalNetworkSettings } from './usePersistExternalNetworkSettings';

type ExternalGeneralSettingsPanelProps = {
  surface: ExternalNetworkDto;
  surfaceId: string;
  isReadOnly: boolean;
};

export function ExternalGeneralSettingsPanel({
  surface,
  surfaceId,
  isReadOnly,
}: ExternalGeneralSettingsPanelProps) {
  const { isUpdating, persist } = usePersistExternalNetworkSettings({
    surfaceId,
    isReadOnly,
  });

  return (
    <ExternalNetworkGeneralSettings
      surface={surface}
      isReadOnly={isReadOnly}
      isUpdating={isUpdating}
      onSave={(updates) => persist({ updates, showSuccessToast: true })}
    />
  );
}
